const COUNTRY_CODE = "countryCode";

export default COUNTRY_CODE;
